import React, { useContext, useEffect, useState } from "react";
import {
  QrCode,
  X,
  ArrowDownLeft,
  ArrowUpRight,
  Droplets,
  Package,
  CalendarClock,
  Search,
  AlertTriangle,
  Send,
} from "lucide-react";
import DistributorMasterLayout from "../../../layouts/distributor/DistributorMasterLayout";
import "../../../assets/styles/distributor/DistributorMilkDiary.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";

import { Html5Qrcode } from "html5-qrcode";
import Swal from "sweetalert2";

/* =============================================
   MOCK DATA
   ============================================= */
const DELIVERED_DATA = [
  {
    id: 1,
    customer: "Ali Ahmed",
    area: "DHA Phase 5",
    liters: 2,
    time: "6:30 AM",
    status: "delivered",
    hasDispute: true,
  },
  {
    id: 2,
    customer: "Sara Khan",
    area: "Gulberg III",
    liters: 1.5,
    time: "6:45 AM",
    status: "delivered",
    hasDispute: false,
  },
  {
    id: 3,
    customer: "Hassan Ali",
    area: "Model Town",
    liters: 3,
    time: "7:00 AM",
    status: "delivered",
    hasDispute: false,
  },
  {
    id: 4,
    customer: "Fatima Noor",
    area: "DHA Phase 6",
    liters: 2,
    time: null,
    status: "pending",
    hasDispute: false,
  },
  {
    id: 5,
    customer: "Usman Tariq",
    area: "Johar Town",
    liters: 1,
    time: null,
    status: "pending",
    hasDispute: false,
  },
];

const RECEIVED_DATA = [
  {
    id: 1,
    supplier: "Farmer Abdul",
    liters: 50,
    time: "5:00 AM",
    quality: "Good",
  },
  {
    id: 2,
    supplier: "Green Valley Dairy",
    liters: 30,
    time: "5:15 AM",
    quality: "Excellent",
  },
  {
    id: 3,
    supplier: "Punjab Milk Farm",
    liters: 20,
    time: "5:30 AM",
    quality: "Good",
  },
];

/* =============================================
   QR Placeholder SVG
   ============================================= */
const QRSvg = () => (
  <svg
    className="distDiary-qr-icon"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10"
      y="10"
      width="30"
      height="30"
      rx="4"
      stroke="#4caf50"
      strokeWidth="4"
      fill="none"
    />
    <rect x="18" y="18" width="14" height="14" rx="2" fill="#4caf50" />
    <rect
      x="60"
      y="10"
      width="30"
      height="30"
      rx="4"
      stroke="#4caf50"
      strokeWidth="4"
      fill="none"
    />
    <rect x="68" y="18" width="14" height="14" rx="2" fill="#4caf50" />
    <rect
      x="10"
      y="60"
      width="30"
      height="30"
      rx="4"
      stroke="#4caf50"
      strokeWidth="4"
      fill="none"
    />
    <rect x="18" y="68" width="14" height="14" rx="2" fill="#4caf50" />
    <rect x="50" y="50" width="6" height="6" rx="1" fill="#4caf50" />
    <rect x="60" y="50" width="6" height="6" rx="1" fill="#4caf50" />
    <rect x="70" y="60" width="6" height="6" rx="1" fill="#4caf50" />
    <rect x="80" y="50" width="6" height="6" rx="1" fill="#4caf50" />
    <rect x="60" y="70" width="6" height="6" rx="1" fill="#4caf50" />
    <rect x="80" y="70" width="6" height="6" rx="1" fill="#4caf50" />
  </svg>
);

/* =============================================
   SCAN QR & RECORD MODAL
   ============================================= */
const ScanQRModal = ({ onClose, getAllEnteries }) => {
  const [liters, setLiters] = useState("");
  const [data, setData] = useState("");
  const { loggedInDistributor, baseUrl } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      function onScanSuccess(decodedText, decodedResult) {
        setData(`${decodedText} ====== ${decodedResult}`);
      }

      const html5QrCode = new Html5Qrcode("reader");

      // Get all cameras and choose the back one
      Html5Qrcode.getCameras()
        .then((devices) => {
          if (devices && devices.length) {
            let backCamera = devices.find((device) =>
              device.label.toLowerCase().includes("back"),
            );

            // if back camera not found, fallback to last camera
            let cameraId = backCamera
              ? backCamera.id
              : devices[devices.length - 1].id;

            html5QrCode.start(
              cameraId,
              {
                fps: 10, // frames per second
                qrbox: { width: 250, height: 250 },
              },
              onScanSuccess,
            );
          }
        })
        .catch((err) => {
          console.error("Error while fetching cameras", err);
        });
    }, 1000);
  }, []);

  const recordEntry = () => {
    const formData = new FormData();
    formData.append("mwcustomer_id", 2);
    formData.append("mwdistributor_id", loggedInDistributor.id);
    formData.append("qty", liters);

    axios
      .post(`${baseUrl}/distributor/diary/recordEntry`, formData, {
        headers: { "Content-Type": "multipart/formdata" },
      })
      .then((res) => {
        console.log(res.data);
        Swal.fire({
          'icon' : 'success',
          'title' : 'Delivery Recorded',
          'content' : res.data.message,
          'confirmButtonText' : 'Okay'
        })
        getAllEnteries();
        onClose();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="distDiary-overlay" onClick={onClose}>
      <div className="distDiary-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distDiary-modal-close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="distDiary-modal-header">
          <h4>Record Entry</h4>
          <p>Scan a customer QR code to record delivery</p>
        </div>
        <div className="bg-light" id="reader"></div>
        {/* <div className="distDiary-qr-area">
          <QRSvg />
          <span className="distDiary-qr-camera-label">
            Camera will open here
          </span>
          <span className="distDiary-qr-camera-sub">Point at QR code</span>
        </div> */}

        <p className="distDiary-qr-hint">
          If scanned QR belongs to a <strong>customer</strong>, it records a
          delivery.
        </p>

        <div className="distDiary-form-field">
          <label>Liters</label>
          <input
            className="distDiary-form-input"
            placeholder="e.g. 2"
            value={liters}
            onChange={(e) => setLiters(e.target.value)}
          />
        </div>

        <div className="distDiary-modal-footer">
          <button className="distDiary-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="distDiary-btn-green" onClick={recordEntry}>
            Record Entry
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   GENERATE DISPUTE MODAL (from Received tab)
   ============================================= */
const GenerateDisputeModal = ({ entry, onClose }) => {
  const [desc, setDesc] = useState("");
  if (!entry) return null;
  return (
    <div className="distDiary-overlay" onClick={onClose}>
      <div className="distDiary-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distDiary-modal-close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="distDiary-modal-header">
          <h4>Generate Dispute</h4>
          <p>Report an issue with supply from {entry.supplier}</p>
        </div>

        <div className="distDiary-dispute-info">
          Supplier: {entry.supplier}
          <br />
          Liters: {entry.liters}L<br />
          Time: {entry.time}
        </div>

        <div className="distDiary-form-field">
          <label>Issue Description</label>
          <input
            className="distDiary-form-input"
            placeholder="e.g. Received less quantity, quality issue..."
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
          />
        </div>

        <div className="distDiary-modal-footer">
          <button className="distDiary-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="distDiary-btn-red" onClick={onClose}>
            Submit Dispute
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   VIEW DISPUTE MODAL (from Delivered tab)
   ============================================= */
const ViewDisputeModal = ({ entry, onClose }) => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([
    {
      system: true,
      text: `Dispute D-001 opened regarding: Short delivery — received 1.5L instead of 2L`,
      time: "10:00 AM",
    },
    {
      system: false,
      sender: entry?.customer,
      text: "Short delivery — received 1.5L instead of 2L",
      time: "10:01 AM",
    },
  ]);

  if (!entry) return null;

  const sendMessage = () => {
    if (!message.trim()) return;
    setMessages((prev) => [
      ...prev,
      { system: false, sender: "You", text: message, time: "Now" },
    ]);
    setMessage("");
  };

  return (
    <div className="distDiary-overlay" onClick={onClose}>
      <div
        className="distDiary-modal"
        style={{ maxWidth: 460 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="distDiary-modal-close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="distDiary-modal-header">
          <h4>D-001 — Dispute Details</h4>
        </div>

        {/* Details grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px 20px",
            marginBottom: 14,
            fontSize: "0.85rem",
          }}
        >
          <div>
            <div style={{ opacity: 0.5, fontSize: "0.75rem", marginBottom: 2 }}>
              Party:
            </div>
            <strong>{entry.customer}</strong>
          </div>
          <div>
            <div style={{ opacity: 0.5, fontSize: "0.75rem", marginBottom: 2 }}>
              Source:
            </div>
            <strong>Customer</strong>
          </div>
          <div>
            <div style={{ opacity: 0.5, fontSize: "0.75rem", marginBottom: 2 }}>
              Priority:
            </div>
            <span
              style={{
                background: "#ef4444",
                color: "#fff",
                borderRadius: 999,
                padding: "3px 12px",
                fontSize: "0.75rem",
                fontWeight: 700,
              }}
            >
              High
            </span>
          </div>
          <div>
            <div style={{ opacity: 0.5, fontSize: "0.75rem", marginBottom: 2 }}>
              Status:
            </div>
            <span
              style={{
                background: "#ef4444",
                color: "#fff",
                borderRadius: 999,
                padding: "3px 12px",
                fontSize: "0.75rem",
                fontWeight: 700,
              }}
            >
              Open
            </span>
          </div>
          <div style={{ gridColumn: "1/-1" }}>
            <div style={{ opacity: 0.5, fontSize: "0.75rem", marginBottom: 2 }}>
              Issue:
            </div>
            <strong style={{ fontSize: "0.875rem" }}>
              Short delivery — received 1.5L instead of 2L
            </strong>
          </div>
        </div>

        {/* Discussion */}
        <div
          style={{
            background: "#f3f6fb",
            borderRadius: 10,
            padding: "12px 14px",
            marginBottom: 12,
            border: "1px solid #eef2f8",
          }}
        >
          <div
            style={{
              fontSize: "0.83rem",
              fontWeight: 700,
              color: "var(--tertiary-color)",
              marginBottom: 10,
            }}
          >
            Discussion
          </div>
          <div
            style={{
              maxHeight: 150,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            {messages.map((m, i) => (
              <div
                key={i}
                style={{
                  background: "#e8eef6",
                  borderRadius: 8,
                  padding: "9px 12px",
                  fontSize: "0.8rem",
                  color: "var(--tertiary-color)",
                  textAlign: m.system ? "center" : "left",
                }}
              >
                {!m.system && (
                  <div style={{ fontWeight: 600, marginBottom: 2 }}>
                    {m.sender}
                  </div>
                )}
                <div>{m.text}</div>
                <div
                  style={{ opacity: 0.45, fontSize: "0.72rem", marginTop: 3 }}
                >
                  {m.time}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Message input */}
        <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
          <input
            className="distDiary-form-input"
            style={{ flex: 1, margin: 0 }}
            placeholder="Type a message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button
            onClick={sendMessage}
            style={{
              width: 38,
              height: 38,
              borderRadius: 9,
              background: "#4caf50",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <Send size={15} style={{ stroke: "#fff" }} />
          </button>
        </div>

        {/* Actions */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            className="distDiary-btn-green"
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
            }}
          >
            Mark as Resolved
          </button>
          <button
            style={{
              flex: 1,
              padding: "9px 14px",
              border: "1.5px solid #d0d9e8",
              borderRadius: 10,
              background: "#fff",
              fontFamily: "var(--font-primary)",
              fontSize: "0.83rem",
              fontWeight: 600,
              color: "var(--tertiary-color)",
              cursor: "pointer",
            }}
          >
            → Forward to Admin
          </button>
        </div>
        <div style={{ textAlign: "right", marginTop: 10 }}>
          <button className="distDiary-btn-cancel" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   MAIN PAGE CONTENT
   ============================================= */
const MilkDiaryContent = () => {
  const [activeTab, setActiveTab] = useState("delivered");
  const [search, setSearch] = useState("");
  const [showScanQR, setShowScanQR] = useState(false);
  const [genDisputeEntry, setGenDisputeEntry] = useState(null);
  const [viewDisputeEntry, setViewDisputeEntry] = useState(null);
  const [milkEnteries, setMilkEnteries] = useState([]);

  const { baseUrl, loggedInDistributor } = useContext(AppContext);

  const receivedToday = RECEIVED_DATA.reduce((s, x) => s + x.liters, 0);
  const deliveredToday = DELIVERED_DATA.filter(
    (d) => d.status === "delivered",
  ).reduce((s, x) => s + x.liters, 0);
  const remainingStock = receivedToday - deliveredToday;
  const pendingCount = DELIVERED_DATA.filter(
    (d) => d.status === "pending",
  ).length;

  const filteredDelivered = DELIVERED_DATA.filter(
    (d) =>
      d.customer.toLowerCase().includes(search.toLowerCase()) ||
      d.area.toLowerCase().includes(search.toLowerCase()),
  );

  const filteredReceived = RECEIVED_DATA.filter((r) =>
    r.supplier.toLowerCase().includes(search.toLowerCase()),
  );

  const getAllEnteries = () => {
    const formData = new FormData();
    formData.append("mwdistributor_id", loggedInDistributor.id);
    axios
      .post(`${baseUrl}/distributor/diary/getAllEnteries`, formData, {
        headers: { "Content-Type": "multipart/formdata" },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data) {
          setMilkEnteries(res.data.enteries);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("This is log from the milk diary");
    getAllEnteries();
  }, []);

  return (
    <div className="distDiary-page">
      {/* Header */}
      <div className="distDiary-header-row">
        <div className="distDiary-title">
          <h2>Daily Milk Diary</h2>
          <p>Track received and delivered milk for today</p>
        </div>
        <button
          className="distDiary-scan-btn"
          onClick={() => setShowScanQR(true)}
        >
          <QrCode size={16} />
          Scan QR &amp; Record
        </button>
      </div>

      {/* Stats */}
      <div className="distDiary-stats-row">
        <div className="distDiary-stat-item">
          <div className="distDiary-stat-icon green">
            <ArrowDownLeft size={20} />
          </div>
          <div className="distDiary-stat-text">
            <span>Received Today</span>
            <h4>{receivedToday}L</h4>
          </div>
        </div>
        <div className="distDiary-stat-item">
          <div className="distDiary-stat-icon blue">
            <ArrowUpRight size={20} />
          </div>
          <div className="distDiary-stat-text">
            <span>Delivered Today</span>
            <h4>{deliveredToday}L</h4>
          </div>
        </div>
        <div className="distDiary-stat-item">
          <div className="distDiary-stat-icon teal">
            <Droplets size={20} />
          </div>
          <div className="distDiary-stat-text">
            <span>Remaining Stock</span>
            <h4>{remainingStock}L</h4>
          </div>
        </div>
        <div className="distDiary-stat-item">
          <div className="distDiary-stat-icon orange">
            <CalendarClock size={20} />
          </div>
          <div className="distDiary-stat-text">
            <span>Pending Deliveries</span>
            <h4>{pendingCount}</h4>
          </div>
        </div>
      </div>

      {/* Tabs */}
      {/* <div className="distDiary-tabs">
        <button
          className={`distDiary-tab-btn ${activeTab === "delivered" ? "active" : ""}`}
          onClick={() => { setActiveTab("delivered"); setSearch(""); }}
        >
          <ArrowUpRight size={14}/> Delivered
        </button>
        <button
          className={`distDiary-tab-btn ${activeTab === "received" ? "active" : ""}`}
          onClick={() => { setActiveTab("received"); setSearch(""); }}
        >
          <ArrowDownLeft size={14}/> Received
        </button>
      </div> */}

      {/* Table Card */}
      <div className="distDiary-table-card">
        <div className="distDiary-table-toolbar">
          <h5>
            {activeTab === "delivered"
              ? "Today's Deliveries"
              : "Today's Received Supply"}
          </h5>
          <div className="distDiary-table-search">
            <Search size={14} />
            <input
              placeholder={
                activeTab === "delivered"
                  ? "Search customer..."
                  : "Search supplier..."
              }
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="distDiary-table-wrap">
          {/* DELIVERED TAB */}
          {activeTab === "delivered" && (
            <table className="distDiary-table">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Area</th>
                  <th>Liters</th>
                  <th>Time</th>
                  <th>Status</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {/* {filteredDelivered.map((row) => ( */}
                {milkEnteries?.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <strong style={{ fontWeight: 600 }}>
                        {row.mwcustomer?.fullName}
                      </strong>
                    </td>
                    <td>{row.mwcustomer?.mwarea?.name || "—"}</td>
                    {/* <td>{row.mwcustomer.mwarea?.name}</td> */}
                    <td>{row.qty}L</td>
                    <td>
                      {row.created_at || (
                        <span className="distDiary-dash">—</span>
                      )}
                    </td>
                    <td>
                      <span
                        className={`distDiary-badge ${row.status === "delivered" ? "distDiary-badge-delivered" : "distDiary-badge-pending"}`}
                      >
                        {row.status.charAt(0).toUpperCase() +
                          row.status.slice(1)}
                      </span>
                    </td>
                    {/* <td>
                      {row.hasDispute ? (
                        <button
                          className="distDiary-dispute-btn"
                          onClick={() => setViewDisputeEntry(row)}
                        >
                          <AlertTriangle size={13}/> View Dispute
                        </button>
                      ) : (
                        <span className="distDiary-dash">—</span>
                      )}
                    </td> */}
                  </tr>
               ) )}
              </tbody>
            </table>
          )}

          {/* RECEIVED TAB */}
          {activeTab === "received" && (
            <table className="distDiary-table">
              <thead>
                <tr>
                  <th>Supplier</th>
                  <th>Liters</th>
                  <th>Time</th>
                  <th>Quality</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredReceived.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <strong style={{ fontWeight: 600 }}>
                        {row.supplier}
                      </strong>
                    </td>
                    <td>{row.liters}L</td>
                    <td>{row.time}</td>
                    <td>
                      <span className="distDiary-badge distDiary-badge-good">
                        {row.quality}
                      </span>
                    </td>
                    <td>
                      <button
                        className="distDiary-gen-dispute-btn"
                        onClick={() => setGenDisputeEntry(row)}
                      >
                        <AlertTriangle size={13} /> Generate Dispute
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modals */}
      {showScanQR && <ScanQRModal getAllEnteries= {getAllEnteries} onClose={() => setShowScanQR(false)} />}
      {genDisputeEntry && (
        <GenerateDisputeModal
          entry={genDisputeEntry}
          onClose={() => setGenDisputeEntry(null)}
        />
      )}
      {viewDisputeEntry && (
        <ViewDisputeModal
          entry={viewDisputeEntry}
          onClose={() => setViewDisputeEntry(null)}
        />
      )}
    </div>
  );
};

const DistributorMilkDiary = () => (
  <DistributorMasterLayout>
    <MilkDiaryContent />
  </DistributorMasterLayout>
);

export default DistributorMilkDiary;
